/**
 * リンクURLからイベントコードを抽出するユーティリティ関数
 */

/**
 * URLが内部イベントリンクかどうかを判定し、イベントコードを抽出する
 * @param url チェックするURL
 * @returns イベントコードまたはnull
 */
export const extractEventCode = (url: string): string | null => {
  try {
    const urlObj = new URL(url);

    // /public-event/{code} の形式をチェック
    const publicEventMatch = urlObj.pathname.match(
      /\/public-event\/([a-f0-9-]+)$/i,
    );
    if (publicEventMatch) {
      return publicEventMatch[1];
    }

    return null;
  } catch (_error) {
    // 無効なURLの場合はnullを返す
    return null;
  }
};

/**
 * URLが内部イベントリンクかどうかを判定する
 * @param url チェックするURL
 * @returns 内部イベントリンクの場合true
 */
export const isInternalEventLink = (url: string): boolean => {
  return extractEventCode(url) !== null;
};
